<template>
  <main class="main" :class="{ 'expand-main': isMenuCollapse }">

    <template v-if="!checkTimeValid">

      <LoadingOliver v-if="currentTimeValid" />

      <div class="row" v-else>
        <div class="col-12 col-md-10 offset-md-1 text-center " >
          <div class="alert alert-primary mx-5 my-2 px-2 py-4 ">
            <h6>
              <i class="fas fa-exclamation-triangle mr-2"></i>
              {{ $t("lang.label.lead_room_access")}}
             </h6>
          </div>

        </div>
      </div>

    </template>

    <template v-else>

    <LoadingOliver v-if="showSpinner" />
    <span v-if="error">{{error}}</span>

      <div class="p-2 px-3" v-if="tasks.length > 0">
      <small class="text-success"> Opportunity {{showTask}} of <span v-if="!loadingMore">{{tasks.length}}</span> <span v-if="loadingMore" class="loadingres mr-1 ml-1 spinner-border loading-spinner text-success"></span> preloaded</small>



      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          :style="getProgress()"
          aria-valuenow="25"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      </div>

    <div v-if="showTask == 1 && !showSpinner && !error">
        <AdminTasks :key="3982348923489243" @showNext="loadNext($event)"></AdminTasks>
    </div>

    <div v-if="showTask > 1 && !showSpinner && !error" >
        <AdminTasks :key="linkId" @showNext="loadNext()" :linkId="linkId" :link="link"></AdminTasks>
    </div>
  </template>
  </main>
</template>

<script>
import moment from "moment";
import AdminTasks from "@/components/Opportunities/SingleOpportunity/AdminTasks.vue";
import { mapState } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import LoadingOliver from "@/components/LoadingOliver.vue";
import {
  opportunitiesService, adminService
} from "@/_services";

function encodeLeadRoomSessionPayload(payload) {
  const json = JSON.stringify(payload);
  return btoa(unescape(encodeURIComponent(json)));
}

function decodeLeadRoomSessionPayload(raw) {
  try {
    const json = decodeURIComponent(escape(atob(raw)));
    return JSON.parse(json);
  } catch (e) {
    return JSON.parse(raw);
  }
}

export default {
  name: 'AdminTasksPage',


  computed:  {
  ...mapState({
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      currentPage: (state) => state.opportunities.currentPage,
      loading: (state) => state.opportunities.loading,
      currentUser: (state) => state.authentication.user,
    }),
  },

  created(){
    if(this.currentUser.booker && !['Training', 'Suspended', 'Stopped', 'Rejected'].includes(this.currentUser.booker.status)){
      this.checkTime()
    } else {
      // redirigo a dashboard
      this.$router.push('/dashboard')
    }

  },

  data() {
    return {
      rangeTimeAvailable: {
        min: "08:00:00",
        max: "20:00:00"
      },
      checkTimeValid: false,
      currentTimeValid: true,
      loadTask: 1,
      showTask: 1,
      linkId: false,
      link: false,
      tasks:[],
      loadingMore: false,
      tasksProcessed: 0,
      showSpinner: false,
      error:"",
      leadRoomAccessCacheKey: "l_r_a_cache",
    };
  },

  components: {
    AdminTasks,
    LoadingSpinner,
    LoadingOliver
  },
  methods:{
    checkTime2(fromOpportunity = false){
    if(this.currentUser.id == 46129){
      // Usuario de prueba, no valido el tiempo
      this.checkTimeValid = true;
      this.currentTimeValid = true;
      return;
    }
      opportunitiesService.getCurrentTime()
        .then((res ) => {

          if(res){
            const currentTime = moment(res).format('HH:mm:ss');

            //Comparo si la currentTime esta dentro de las 8 a 20 horas

            //Sino se encuentra en el rango entonces muestro mensaje de aviso de no acceso Ejemplo min -> 08:00:00 max -> 20:00:00
            if(!(currentTime >= this.rangeTimeAvailable.min && currentTime <= this.rangeTimeAvailable.max)){

              if(fromOpportunity){

                this.checkTimeValid = false
                this.currentTimeValid = false;

              } else {

                this.currentTimeValid = false;

              }

            } else { //En este caso sigue curso normal de la carga de la vista
              this.checkTimeValid = true
            }

          } else {
            this.checkTimeValid = true
          }
      })
      .catch((err) => {
        this.checkTimeValid = true
        console.log(err)
      })
    },

    checkTime(fromOpportunity = false) {
      if (this.currentUser.id == 46129) {
        // Usuario de prueba, no valido el tiempo
        this.checkTimeValid = true;
        this.currentTimeValid = true;
        return true;
      }

      const cachedAccess = this.getLeadRoomAccessFromSession();

      if (cachedAccess && this.isLeadRoomCacheStillValid(cachedAccess)) {
        this.applyLeadRoomAccess(cachedAccess.allowed, fromOpportunity);
        return cachedAccess.allowed;
      }

      this.fetchLeadRoomAccessFromBackend(fromOpportunity);

      // Mientras espera la respuesta del backend, no bloqueamos sin necesidad.
      // La respuesta async actualizará checkTimeValid/currentTimeValid.
      return null;
    },

    getLeadRoomAccessFromSession() {
      const raw = sessionStorage.getItem(this.leadRoomAccessCacheKey);

      if (!raw) {
        return null;
      }

      try {
        return decodeLeadRoomSessionPayload(raw);
      } catch (e) {
        sessionStorage.removeItem(this.leadRoomAccessCacheKey);
        return null;
      }
    },

    isLeadRoomCacheStillValid(cachedAccess) {
      if (!cachedAccess) {
        return false;
      }

      if (!cachedAccess.next_check_at_client_timestamp_ms) {
        return false;
      }

      if (!cachedAccess.performance_time_at_fetch) {
        return false;
      }

      if (!cachedAccess.next_check_in_seconds) {
        return false;
      }

       // Si el usuario presionó F5 o se reinició el contexto de navegación,
      // performance.now() puede volver a empezar desde 0.
      // En ese caso invalidamos el cache y volvemos a consultar al backend.
      if (performance.now() < cachedAccess.performance_time_at_fetch) {
        return false;
      }


      const elapsedMs = performance.now() - cachedAccess.performance_time_at_fetch;

      // Si elapsedMs es negativo, probablemente hubo reload de la página
      // o el valor de performance.now() ya no corresponde.
      if (elapsedMs < 0) {
        return false;
      }

      const maxCacheLifeMs = cachedAccess.next_check_in_seconds * 1000;

      // Validación principal usando performance.now()
      // Esto evita depender totalmente de la hora local del sistema.
      if (elapsedMs >= maxCacheLifeMs) {
        return false;
      }

      // Validación secundaria usando Date.now()
      // Sirve como respaldo para no dejar vivo el cache más de lo debido.
      if (Date.now() >= cachedAccess.next_check_at_client_timestamp_ms) {
        return false;
      }

      return true;
    },

    fetchLeadRoomAccessFromBackend(fromOpportunity = false) {
      opportunitiesService.getCurrentTime()
        .then((res) => {
          if (!res) {
            this.checkTimeValid = true;
            this.currentTimeValid = true;
            return;
          }

          const cachePayload = {
            allowed: res.allowed,
            server_timestamp_ms: res.server_timestamp_ms,
            valid_until_timestamp_ms: res.valid_until_timestamp_ms,
            next_check_in_seconds: res.next_check_in_seconds,

            // Datos locales para saber cuándo volver a consultar
            client_timestamp_at_fetch_ms: Date.now(),
            performance_time_at_fetch: performance.now(),
            next_check_at_client_timestamp_ms: Date.now() + (res.next_check_in_seconds * 1000)
          };

          sessionStorage.setItem(
            this.leadRoomAccessCacheKey,
            encodeLeadRoomSessionPayload(cachePayload)
          );

          this.applyLeadRoomAccess(res.allowed, fromOpportunity);
        })
        .catch((err) => {
          console.log(err);

          // Podés decidir permitir o bloquear si falla el backend.
          // Por seguridad, mejor bloquear.
          this.checkTimeValid = false;
          this.currentTimeValid = false;
        });
    },

    applyLeadRoomAccess(allowed, fromOpportunity = false) {
      if (!allowed) {
        if (fromOpportunity) {
          this.checkTimeValid = false;
          this.currentTimeValid = false;
        } else {
          this.currentTimeValid = false;
        }

        return;
      }

      this.checkTimeValid = true;
      this.currentTimeValid = true;
    },

    getProgress() {
      let percentage = (this.showTask * 100) / this.tasks.length;
      return "width: " + percentage + "%";
    },

    loadNext(tasks){
      //this.checkTime(true)

      const allowed = this.checkTime(true);

      if (allowed === false) {
        return;
      }


      if(tasks){
        this.tasks = tasks
      }

      if(!this.loadingMore && this.showTask == (this.tasks.length)) {
          this.error = "We were unable to preload more, please refresh your browser";
          return;
      }


      this.error = "";

      if(this.loadingMore && this.showTask == (this.tasks.length-1)) {
          this.showSpinner = true;
          return;
      }

      this.tasksProcessed++;

      if((this.tasks.length - 2) <= this.tasksProcessed && !this.loadingMore){
         this.loadingMore = true;

          opportunitiesService.getNextTask().then(({ result, status }) => {
              if(result && status == '200' && result.task.length > 0) {
                  // Filtrar objetos de array2 que no existan en array1
                  const nuevosObjetos = result.task.filter(obj2 =>
                      !this.tasks.some(obj1 => obj1.link_id === obj2.link_id)
                  );

                  // Agregar al final del array1
                  this.tasks = [...this.tasks, ...nuevosObjetos];
              }

              this.loadingMore = false;
              if(this.showSpinner){

                this.showSpinner = false;
                if(tasks){
                  this.tasks = tasks
                }

                this.linkId = this.tasks[this.showTask].link_id
                this.link =  this.tasks[this.showTask]
                this.showTask++

                return;
              }

          });
      }


      this.linkId = this.tasks[this.showTask].link_id
      this.link =  this.tasks[this.showTask]
      this.showTask++


    }
  }

};
</script>
